<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div> <br>
<div class="col-sm-12 action-buttons-container">
  <div class=" button-continer" *ngFor="let button of buttonList" style="margin-left: 10px;">
    <button *ngIf="button == 'Cancel'" mat-stroked-button class="cancelButton" (click)="cancelFindingDetails()">
      {{button}}
    </button>
    <button *ngIf="button != 'Cancel' && button != '' && button != 'Save'" mat-stroked-button class="addButton"
      (click)="dynamicButtonClick(button)"> {{button}}
    </button>
  </div>
</div>

<div class="col-sm-12 action-buttons-container" style="padding-right: 1%;" *ngIf="isDataLoaded">
  <span class="crDetail-status1" [ngStyle]="{'color':getColor(findingsDetailsData.status) , 'zoom':'1.3'}">
    Status&nbsp;:&nbsp;
    <span>{{this.findingsDetailsData.status}}/{{this.tempAuditStatus}}</span>
  </span>&nbsp;&nbsp;
</div>
<div class="col-sm-12 action-buttons-container" style="padding-right: 1%;">
  <label for="email" *ngIf="noteResult!=null">{{noteResult}}</label>
</div> <br>

<div class="row">
  <div class="col-sm-11 slider" style="margin:5px; text-align:center" *ngIf="findingsList.length > 1">
    <button class="slide-button" style="all: unset;" (click)="first()" [disabled]="viewingSequence === 1"
      matTooltip="To first" *ngIf="findingsList.length > 2"
      [ngStyle]="viewingSequence === 1 ? {'cursor' : 'not-allowed'} : {'cursor' : 'pointer'}">
      <img src="../../../assets/img/to-first-arrow.png" width="15px" height="15px" alt="first" />
    </button>
    &nbsp;&nbsp;
    <button class="slide-button" style="all: unset;" (click)="backward()" [disabled]="viewingSequence === 1"
      matTooltip="Previous" [ngStyle]="viewingSequence === 1 ? {'cursor' : 'not-allowed'} : {'cursor' : 'pointer'}">
      <img src="../../../assets/img/back-arrow.png" width="15px" height="15px" alt="back" />
    </button>
    &nbsp;&nbsp;
    {{viewingSequence}} / {{findingsList.length}}
    &nbsp;&nbsp;
    <button class="slide-button" style="all: unset;" (click)="forward()"
      [disabled]="viewingSequence === findingsList.length" matTooltip="Next"
      [ngStyle]="viewingSequence === findingsList.length ? {'cursor' : 'not-allowed'} : {'cursor' : 'pointer'}">
      <img src="../../../assets/img/next-arrow.png" width="15px" height="15px" alt="next" />
    </button>
    &nbsp;&nbsp;
    <button class="slide-button" style="all: unset;" (click)="last()" *ngIf="findingsList.length > 2"
      [disabled]="viewingSequence === findingsList.length" matTooltip="To last"
      [ngStyle]="viewingSequence === findingsList.length ? {'cursor' : 'not-allowed'} : {'cursor' : 'pointer'}">
      <img src="../../../assets/img/to-last-arrow.png" width="15px" height="15px" alt="last" />
    </button>
  </div>
  <div class="col-sm-11 slider" style="margin:5px; text-align:center" *ngIf="2 > findingsList.length">
  </div>
  <div class="d-flex gap-2 col-sm-1" style="margin-left: -10px;">
    <div class="d-flex align-items-center justify-content-center communication_cta pointer"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')" matTooltip="PDF">
      <img src="../../../assets/img/cr_module/pdf.svg" width="11px" height="15px" alt="" />
    </div>
    <div class="d-flex align-items-center justify-content-center communication_cta pointer"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')" matTooltip="Excel">
      <img src="../../../assets/img/DMS/excel.svg" width="14px" height="14px" alt="" />
    </div>
  </div>
</div>

<mat-tab-group mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
  (selectedTabChange)="onTabClick($event)">

  <mat-tab label="Audit">
    <ng-template mat-tab-label>
      <span>
        <i class='fa-solid fa-file-pen' style="font-size: 26px;" aria-hidden="true"></i>
      </span>&nbsp;<span>Audit Finding Details</span>
    </ng-template>
    <fieldset *ngIf="dynamicLabel" class="border p-2 fieldsetStyle" style="margin-top: 2%; margin-bottom: 2%;">
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-6 auditor-section">
            <fieldset class="border p-2 fieldsetStyle">
              <legend class="float-none w-auto p-2">
                <span class="" style="font-size: 14px;color: #a7a5a5;">Auditor</span>
              </legend>
              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="short-description-validation" for="email">
                    {{dynamicLabel['FINDING_SHORT_DESCRIPTION'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['FINDING_SHORT_DESCRIPTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['FINDING_SHORT_DESCRIPTION']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="col-sm-11">
                    <input class="form-control" type="text" [(ngModel)]="findingsDetailsData.findingShortDescription"
                      (blur)="onNgModelChange($event,'short-description-validation')" [disabled]="auditorSectionFrozen"
                      (focusout)="onFieldFocusout()">
                  </div>
                </div>
              </div>

              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="finding-validation" for="email">
                    {{dynamicLabel['FINDING'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['FINDING']?.fieldNotes"
                    [matTooltip]="dynamicLabel['FINDING']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.finding"
                      (blur)="onNgModelChange($event,'finding-validation')" [config]="config"
                      [disabled]="auditorSectionFrozen" [spellcheck]="true" (focusout)="onFieldFocusout()"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="auditorSectionFrozen ? openEditor('Finding', 'eye') : openEditor('Finding', 'edit')"
                    (keydown.enter)="auditorSectionFrozen ? openEditor('Finding', 'eye') : openEditor('Finding', 'edit')">
                    <i *ngIf="!auditorSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="auditorSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <ng-container *ngIf="dynamicLabel['REQUESTED_AT']?.isRemovable != 'Y'">
                <div class="row inner-align">
                  <div class="col-md-5 inner-align">
                    <div>
                      <label id="requested-at" for="email">
                        {{dynamicLabel['REQUESTED_AT']?.fieldName}}
                      </label>
                      <span style="float:right" *ngIf="dynamicLabel['REQUESTED_AT']?.fieldNotes"
                        [matTooltip]="dynamicLabel['REQUESTED_AT']?.fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="findingsDetailsData.requestedAt"
                      (closed)="requestedAtSearchText=''" (click)="focusSearch('focus-requested-at')"
                      (keydown.enter)="focusSearch('focus-requested-at')"
                      [ngClass]="{'odd-item-mat-select': isRequestedAtOdd == findingsDetailsData.requestedAt}"
                      [disabled]="auditorSectionFrozen">
                      <input type="search" id="focus-requested-at" class="dropdownsearchstyle"
                        [(ngModel)]="requestedAtSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" (onSelectionChange)="onRequestedAtSelect($event, null)"
                        [value]="null">Un-select</mat-option>
                      <mat-option *ngFor="let item of requestedAtDropdown | assessmentSearch :requestedAtSearchText"
                        (onSelectionChange)="onRequestedAtSelect($event,item)" [value]="item.valueExp">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>

                  <div class="col-md-7 inner-align" *ngIf="findingsDetailsData.requestedAt">
                    <div>
                      <label id="business-area" for="email">
                        {{((findingsDetailsData.requestedAt ?? ' ') + ' ' +
                        dynamicLabel['CORE_BUSINESS_AREA_NAME']?.fieldName)}}
                      </label> <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput multiple placeholder="Select" #businessArea [(ngModel)]="selectedBusinessArea"
                      *ngIf="businessAreaDropdown.length" (closed)="businessAreaSearchText=''"
                      [matTooltip]="getTooltip()" (click)="focusSearch('focus-b-area')"
                      [disabled]="auditorSectionFrozen" (keydown.enter)="focusSearch('focus-b-area')">
                      <input type="search" id="focus-b-area" class="dropdownsearchstyle"
                        [(ngModel)]="businessAreaSearchText" matInput placeholder="search">
                      <div class="select-all">
                        <mat-checkbox [(ngModel)]="isAllBusinessAreaSelected" (change)="toggleAllBusinessArea()">Select
                          All</mat-checkbox>
                      </div>
                      <mat-option
                        *ngFor="let item1 of businessAreaDropdown | multiAssessmentSearchPipe : businessAreaSearchText"
                        [value]="item1.valueExp" (onSelectionChange)="onBusinessAreaSelect($event,item1)">
                        {{ item1.displayExp }}
                      </mat-option>
                    </mat-select>
                    <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                      *ngIf="!businessAreaDropdown.length" [disabled]="auditorSectionFrozen"
                      [(ngModel)]="findingsDetailsData.coreBusinessAreaName"
                      (input)="limitCharacters($event, 'BUSINESS_AREA')"></textarea>
                  </div>
                </div>
              </ng-container>

              <div class="col-md-12 inner-align" [hidden]="dynamicLabel['REFERENCE']?.isRemovable == 'Y'">
                <div class="row">
                  <label id="reference-validation" for="email">
                    {{ dynamicLabel['REFERENCE'].fieldName }}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REFERENCE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REFERENCE']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>

                <div class="row align-items-center">
                  <div class="col-sm-11 pl-0 pr-1 hideToolbar">
                    <st-editor [(ngModel)]="findingsDetailsData.reference" [config]="config"
                      [disabled]="auditorSectionFrozen" (paste)="onPaste($event)" [spellcheck]="true"
                      (focusout)="onFieldFocusout()" (blur)="onNgModelChange($event, 'reference-validation')">
                    </st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit pl-0 pr-0"
                    (click)="auditorSectionFrozen  ? openEditor('Reference', 'eye') : openEditor('Reference', 'edit')"
                    (keydown.enter)="auditorSectionFrozen  ? openEditor('Reference', 'eye') : openEditor('Reference', 'edit')">
                    <i *ngIf="!((auditorSectionFrozen))" class="far fa-edit"></i>
                    <i *ngIf="(auditorSectionFrozen)" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-12 inner-align" [hidden]="dynamicLabel['DELIVERABLES']?.isRemovable == 'Y'">
                <div class="row">
                  <label id="deliverables-validation" for="email">
                    {{dynamicLabel['DELIVERABLES'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['DELIVERABLES']?.fieldNotes"
                    [matTooltip]="dynamicLabel['DELIVERABLES']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.deliverables"
                      (blur)="onNgModelChange($event,'finding-validation')" [config]="config"
                      [disabled]="auditorSectionFrozen" (paste)="onPaste($event)" [spellcheck]="true"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="auditorSectionFrozen ? openEditor('Deliverables', 'eye') : openEditor('Deliverables', 'edit')"
                    (keydown.enter)="auditorSectionFrozen ? openEditor('Deliverables', 'eye') : openEditor('Deliverables', 'edit')">
                    <i *ngIf="!auditorSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="auditorSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <div class="row inner-align">
                <div class="col-md-6">
                  <div>
                    <label id="severity-validation" for="email">{{dynamicLabel['SEVERITY'].fieldName}}
                      <span class="mandatory-symbol">*</span>
                      <span class="qms-risk-icon" style="padding: 2px;"
                        [matTooltip]="'Update ' + dynamicLabel['SEVERITY']?.fieldName" (click)="openUpdateType()"
                        (keydown.enter)="openUpdateType()" *ngIf="showUpdateType">
                        <svg width="20" height="20" fill="#000000" viewBox="0 0 36 36" version="1.1"
                          preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              d="M19.5,28.1h-2.9c-0.5,0-0.9-0.3-1-0.8l-0.5-1.8c-0.2-0.1-0.2-0.1-0.4-0.2l-1.6,0.9c-0.4,0.2-0.9,0.2-1.2-0.2l-2.1-2.1 c-0.3-0.3-0.4-0.8-0.2-1.2l0.9-1.6c-0.1-0.2-0.1-0.2-0.2-0.4l-1.8-0.5c-0.4-0.1-0.8-0.5-0.8-1v-2.9c0-0.5,0.3-0.9,0.8-1l1.8-0.5 c0.1-0.2,0.1-0.2,0.2-0.4l-0.9-1.6c-0.2-0.4-0.2-0.9,0.2-1.2l2.1-2.1c0.3-0.3,0.8-0.4,1.2-0.2l1.6,0.9c0.2-0.1,0.2-0.1,0.4-0.2 l0.5-1.8c0.1-0.4,0.5-0.8,1-0.8h2.9c0.5,0,0.9,0.3,1,0.8l0.5,1.8c0.2,0.1,0.2,0.1,0.4,0.2l1.6-0.9c0.4-0.2,0.9-0.2,1.2,0.2 l2.1,2.1c0.3,0.3,0.4,0.8,0.2,1.2l-0.9,1.6c0.1,0.2,0.1,0.2,0.2,0.4l1.8,0.5c0.4,0.1,0.8,0.5,0.8,1v2.9c0,0.5-0.3,0.9-0.8,1 l-1.8,0.5c-0.1,0.2-0.1,0.2-0.2,0.4l0.9,1.6c0.2,0.4,0.2,0.9-0.2,1.2l-2.1,2.1c-0.3,0.3-0.8,0.4-1.2,0.2l-1.6-0.9 c-0.2,0.1-0.2,0.1-0.4,0.2l-0.5,1.8C20.3,27.8,19.9,28.1,19.5,28.1z M17.3,26.1h1.4l0.5-2.1l0.5-0.2c0.4-0.1,0.7-0.3,1.1-0.4 l0.5-0.3l1.9,1.1l1-1l-1.1-1.9l0.3-0.5c0.2-0.3,0.3-0.7,0.4-1.1l0.2-0.5l2.1-0.5v-1.4L24,16.8l-0.2-0.5c-0.1-0.4-0.3-0.7-0.4-1.1 l-0.3-0.5l1.1-1.9l-1-1l-1.9,1.1l-0.5-0.3c-0.3-0.2-0.7-0.3-1.1-0.4L19.2,12l-0.5-2.1h-1.4L16.8,12l-0.5,0.2 c-0.4,0.1-0.7,0.3-1.1,0.4l-0.5,0.3l-1.9-1.1l-1,1l1.1,1.9l-0.3,0.5c-0.2,0.3-0.3,0.7-0.4,1.1L12,16.8l-2.1,0.5v1.4l2.1,0.5 l0.2,0.5c0.1,0.4,0.3,0.7,0.4,1.1l0.3,0.5l-1.1,1.9l1,1l1.9-1.1l0.5,0.3c0.3,0.2,0.7,0.3,1.1,0.4l0.5,0.2L17.3,26.1z M27.1,19.5 L27.1,19.5L27.1,19.5z">
                            </path>
                            <path
                              d="M18,22.3c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3S20.4,22.3,18,22.3z M18,15.7 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3S19.3,15.7,18,15.7z">
                            </path>
                            <path
                              d="M18,2c-0.6,0-1,0.4-1,1s0.4,1,1,1c7.7,0,14,6.3,14,14s-6.3,14-14,14S4,25.7,4,18c0-2.8,0.8-5.5,2.4-7.8v1.2 c0,0.6,0.4,1,1,1s1-0.4,1-1v-5h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h1.8C3.1,11.1,2,14.5,2,18c0,8.8,7.2,16,16,16s16-7.2,16-16 S26.8,2,18,2z">
                            </path>
                            <rect width="36" height="36" fill-opacity="0"></rect>
                          </g>
                        </svg>
                      </span>
                    </label>
                    <span class="info-icon" *ngIf="dynamicLabel['SEVERITY']?.fieldNotes"
                      [matTooltip]="dynamicLabel['SEVERITY']?.fieldNotes">
                      <img [src]="infoIconSrc" alt="note" width="18" height="18">
                    </span>
                  </div>
                  <mat-select matInput placeholder="Select" [(ngModel)]="selectedSeverity" (closed)="severityTxt=''"
                    (click)="focusMethod('severitySearch')" (keydown.enter)="focusMethod('severitySearch')"
                    [disabled]="auditorSectionFrozen"
                    [ngClass]="{'odd-item-mat-select':isSeverityOdd==selectedSeverity}">
                    <input type="search" id="severitySearch" class="dropdownsearchstyle" [(ngModel)]="severityTxt"
                      matInput placeholder="search">
                    <mat-option class="unselectStyle" (onSelectionChange)="onSelect($event,'severity-validation',null);"
                      [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of severityDropdown| assessmentSearch :severityTxt"
                      (onSelectionChange)="onSelect($event,'severity-validation',item);" [value]="item.valueExp">
                      {{ item.displayExp }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>

              <div class="col-md-12 inner-align" style="margin-top: 50px;"
                [hidden]="dynamicLabel['AUDITOR_COMMENTS']?.isRemovable == 'Y'">
                <div class="row">
                  <label id="auditor-comments-validation" for="email">
                    {{dynamicLabel['AUDITOR_COMMENTS'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['AUDITOR_COMMENTS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['AUDITOR_COMMENTS']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.auditorComments" [config]="config"
                      [disabled]="auditorSectionFrozen && !elite_lead_auditor" (paste)="onPaste($event)"
                      [spellcheck]="true"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="auditorSectionFrozen && !elite_lead_auditor ? openEditor('Auditor Comments', 'eye') : openEditor('Auditor Comments', 'edit')"
                    (keydown.enter)="auditorSectionFrozen && !elite_lead_auditor ? openEditor('Auditor Comments', 'eye') : openEditor('Auditor Comments', 'edit')">
                    <i *ngIf="!(auditorSectionFrozen && !elite_lead_auditor)" class="far fa-edit"></i>
                    <i *ngIf="auditorSectionFrozen && !elite_lead_auditor" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>

          <div class="col-sm-6 auditee-section">
            <fieldset class="border p-2 fieldsetStyle">
              <legend class="float-none w-auto p-2">
                <span class="" style="font-size: 14px;color: #a7a5a5;">Auditee</span>
              </legend>
              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="root-cause-validation" for="email">
                    {{dynamicLabel['ROOT_CAUSE_ANALYSIS'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['ROOT_CAUSE_ANALYSIS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['ROOT_CAUSE_ANALYSIS']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.rootCauseAnalysis"
                      (blur)="onNgModelChange($event,'root-cause-validation')" [config]="config"
                      [disabled]="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      (paste)="onPaste($event)" [spellcheck]="true" (focusout)="onFieldFocusout()"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Root Cause Analysis', 'eye') : openEditor('Root Cause Analysis', 'edit')"
                    (keydown.enter)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Root Cause Analysis', 'eye') : openEditor('Root Cause Analysis', 'edit')">
                    <i *ngIf="!((auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze)"
                      class="far fa-edit"></i>
                    <i *ngIf="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="immediate-correction-validation" for="email">
                    {{dynamicLabel['IMMEDIATE_CORRECTION'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IMMEDIATE_CORRECTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IMMEDIATE_CORRECTION']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.immediateCorrection"
                      (blur)="onNgModelChange($event,'immediate-correction-validation')"
                      [disabled]="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze" [config]="config"
                      [spellcheck]="true" (paste)="onPaste($event)" (focusout)="onFieldFocusout()"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Immediate Correction', 'eye') : openEditor('Immediate Correction', 'edit')"
                    (keydown.enter)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Immediate Correction', 'eye') : openEditor('Immediate Correction', 'edit')">
                    <i *ngIf="!((auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze)"
                      class="far fa-edit"></i>
                    <i *ngIf="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="corrective-action-validation" for="email">
                    {{dynamicLabel['CORRECTIVE_ACTION'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['CORRECTIVE_ACTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CORRECTIVE_ACTION']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.correctiveAction"
                      (blur)="onNgModelChange($event,'corrective-action-validation')" [config]="config"
                      [disabled]="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      (paste)="onPaste($event)" [spellcheck]="true" (focusout)="onFieldFocusout()"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Corrective Action', 'eye') : openEditor('Corrective Action', 'edit')"
                    (keydown.enter)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Corrective Action', 'eye') : openEditor('Corrective Action', 'edit')">
                    <i *ngIf="!((auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze)"
                      class="far fa-edit"></i>
                    <i *ngIf="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-12 inner-align">
                <div class="row">
                  <label id="preventive-action-validation" for="email">
                    {{dynamicLabel['PREVENTIVE_ACTION'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['PREVENTIVE_ACTION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['PREVENTIVE_ACTION']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="findingsDetailsData.preventiveAction"
                      (blur)="onNgModelChange($event,'preventive-action-validation')" [config]="config"
                      [disabled]="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      (paste)="onPaste($event)" [spellcheck]="true" (focusout)="onFieldFocusout()"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (click)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Preventive Action', 'eye') : openEditor('Preventive Action', 'edit')"
                    (keydown.enter)="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze ? openEditor('Preventive Action', 'eye') : openEditor('Preventive Action', 'edit')">
                    <i *ngIf="!((auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze)"
                      class="far fa-edit"></i>
                    <i *ngIf="(auditeeSectionFrozen && !elite_response_reviewer) || elite_freeze"
                      class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

              <div class="row inner-align">
                <div class="col-md-6 inner-align">
                  <div>
                    <label for="email" id="expectedCaClosureDate-validation">
                      {{dynamicLabel['EXPECTED_CA_CLOSURE_DATE'].fieldName}}
                    </label>
                    <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_CA_CLOSURE_DATE']?.fieldNotes"
                      [matTooltip]="dynamicLabel['EXPECTED_CA_CLOSURE_DATE']?.fieldNotes">
                      <img [src]="infoIconSrc" alt="note" width="18" height="18">
                    </span>
                    <span class="mandatory-symbol" *ngIf="findingsDetailsData.status=='Pending Response Verification'||
                                                findingsDetailsData.status=='Pending Response Verification'">*</span>
                  </div>
                  <input type="text" class="form-control data-picker-continer" bsDatepicker
                    [disabled]="auditeeSectionFrozen && !elite_response_reviewer"
                    [bsConfig]="$get_ca_pa_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
                    [(ngModel)]="findingsDetailsData.expectedCaClosureDate"
                    (bsValueChange)="onCaClosureDateChange($event)">
                </div>
                <div class="col-md-6 inner-align">
                  <div>
                    <label for="email" id="expectedPaClosureDate-validation">
                      {{dynamicLabel['EXPECTED_PA_CLOSURE_DATE'].fieldName}}
                    </label>
                    <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_PA_CLOSURE_DATE']?.fieldNotes"
                      [matTooltip]="dynamicLabel['EXPECTED_PA_CLOSURE_DATE']?.fieldNotes">
                      <img [src]="infoIconSrc" alt="note" width="18" height="18">
                    </span>
                  </div>
                  <input type="text" class="form-control data-picker-continer" bsDatepicker
                    [disabled]="auditeeSectionFrozen && !elite_response_reviewer"
                    [bsConfig]="$get_ca_pa_dynamic_config()" [dateCustomClasses]="dateCustomClasses"
                    [(ngModel)]="findingsDetailsData.expectedPaClosureDate">
                </div>
              </div>

              <div class="col-md-12 inner-align" [hidden]="dynamicLabel['COMMENTS']?.isRemovable == 'Y'">
                <div class="field-row-down">
                  <label id="comments-validation" for="email">
                    {{ dynamicLabel['COMMENTS'].fieldName }}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['COMMENTS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['COMMENTS']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>

                <div class="row align-items-center">
                  <div class="col-sm-11 pl-0 pr-1 hideToolbar">
                    <st-editor [(ngModel)]="findingsDetailsData.comments" [config]="config"
                      [disabled]="(auditeeSectionFrozen && !elite_assign_to_user_level_2)" (paste)="onPaste($event)"
                      [spellcheck]="true" (focusout)="onFieldFocusout()"
                      (blur)="onNgModelChange($event, 'comments-validation')">
                    </st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit pl-0 pr-0"
                    (click)="(auditeeSectionFrozen && !elite_assign_to_user_level_2) ? openEditor('Comments', 'eye') : openEditor('Comments', 'edit')"
                    (keydown.enter)="(auditeeSectionFrozen && !elite_assign_to_user_level_2) ? openEditor('Comments', 'eye') : openEditor('Comments', 'edit')">
                    <i *ngIf="!((auditeeSectionFrozen && !elite_assign_to_user_level_2))" class="far fa-edit"></i>
                    <i *ngIf="(auditeeSectionFrozen && !elite_assign_to_user_level_2) " class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>

            </fieldset>
          </div>

          <div class="row">
            <div class="col-md-3 inner-align">
              <div>
                <label for="email" id="assign-to-validation">
                  {{dynamicLabel['ASSIGNED_TO'].fieldName}}</label>
                <label for="email" *ngIf="message.showSwitchUser">
                  <a (click)="openSwitchUser('Assigned To')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                      height="25">
                  </a> <span *ngIf="auditorSectionFrozen" class="mandatory-symbol">*</span></label>

                <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedAssignedToUser"
                (closed)="assignedToUserTxt=''" (click)="focusMethod('assignedToUserSearch')"
                (keydown.enter)="focusMethod('assignedToUserSearch')"
                [ngClass]="{'odd-item-mat-select': isAssignedToUserOdd == selectedAssignedToUser}"
                [disabled]="auditorSectionFrozen&& !elite_primary_auditee">
                <input type="search" id="assignedToUserSearch" class="dropdownsearchstyle"
                  [(ngModel)]="assignedToUserTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" (onSelectionChange)="onSelect($event,'assign-to-validation',null);"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of assignedToUserDropDown| assessmentSearch :assignedToUserTxt"
                  (onSelectionChange)="onSelect($event,'assign-to-validation',item);" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3 inner-align">
              <div>
                <label for="email">{{dynamicLabel['ASSIGNED_TO_DEPARTMENT'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO_DEPARTMENT']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO_DEPARTMENT']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedAssignedToDepartment"
                (closed)="assignedToDepartmentTxt=''" (click)="focusMethod('assignedToDepartmentSearch')"
                (keydown.enter)="focusMethod('assignedToDepartmentSearch')"
                [ngClass]="{'odd-item-mat-select': isAssignedToDepartmentOdd == selectedAssignedToDepartment}"
                [disabled]="auditorSectionFrozen&& !elite_primary_auditee">
                <input type="search" id="assignedToDepartmentSearch" class="dropdownsearchstyle"
                  [(ngModel)]="assignedToDepartmentTxt" matInput placeholder="search">
                <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of departmentCodeDropdown| assessmentSearch: assignedToDepartmentTxt"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>
            <div class="col-md-6 inner-align" [hidden]="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.isRemovable == 'Y'">
              <div class="field-row-down">
                <label id="responsibilityUserDetails-validation" for="email">
                  {{ dynamicLabel['ASSIGNED_TO_USER_DETAILS'].fieldName }}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ASSIGNED_TO_USER_DETAILS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>

              <div class="row align-items-center">
                <div class="col-sm-11 pl-0 pr-1 hideToolbar">
                  <st-editor [(ngModel)]="findingsDetailsData.assignedToUserDetails" [config]="config"
                    [disabled]="(auditorSectionFrozen  && !elite_primary_auditee)" (paste)="onPaste($event)"
                    [spellcheck]="true" (focusout)="onFieldFocusout()">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit pl-0 pr-0"
                  (click)="(auditorSectionFrozen  && !elite_primary_auditee)  ? openEditor('Assigned To User Details', 'eye') : openEditor('Assigned To User Details', 'edit')"
                  (keydown.enter)="(auditorSectionFrozen  && !elite_primary_auditee)  ? openEditor('Assigned To User Details', 'eye') : openEditor('Assigned To User Details', 'edit')">
                  <i *ngIf="!((auditorSectionFrozen  && !elite_primary_auditee) )" class="far fa-edit"></i>
                  <i *ngIf="(auditorSectionFrozen  && !elite_primary_auditee)" class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3 inner-align" [hidden]="this.findingsDetailsData.responseReviewedByUser==0">
              <div>
                <label for="email" id="response-reviewer-validation">
                  {{dynamicLabel['RESPONSE_REVIEWER'].fieldName}}
                </label>
                <label for="email" *ngIf="message.showSwitchUser">
                  <a (click)="openSwitchUser('Response Reviewer')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                      height="25">
                  </a>
                </label> <span class="mandatory-symbol">*</span>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEWER']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedResponseReviewUser"
                (closed)="responseReviewUserTxt=''" (click)="focusMethod('responseReviewUserSearch')"
                (keydown.enter)="focusMethod('responseReviewUserSearch')"
                [ngClass]="{'odd-item-mat-select':isResponseReviewUserOdd==selectedResponseReviewUser}"
                [disabled]="auditeeSectionFrozen">
                <input type="search" id="responseReviewUserSearch" class="dropdownsearchstyle"
                  [(ngModel)]="responseReviewUserTxt" matInput placeholder="search">
                <mat-option class="unselectStyle"
                  (onSelectionChange)="onSelect($event,'response-reviewer-validation',null);"
                  [value]="null">Un-select</mat-option>
                <mat-option *ngFor="let item of responseReviewDropdown| assessmentSearch :responseReviewUserTxt"
                  (onSelectionChange)="onSelect($event,'response-reviewer-validation',item);" [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3 inner-align"
              [hidden]="findingsDetailsData.isCapaRequired || this.findingsDetailsData.implementationReviewedByUser == 0">
              <div>
                <label for="email" id="implementation-reviewer-validation">
                  {{dynamicLabel['IMPLEMENTATION_REVIEWER'].fieldName}}
                </label>
                <label for="email" *ngIf="message.showSwitchUser">
                  <a (click)="openSwitchUser('Implementation Reviewer')">
                    <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                      height="25">
                  </a>
                </label> <span class="mandatory-symbol">*</span>

                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEWER']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEWER']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-select matInput placeholder="Select" [(ngModel)]="selectedImplementationReviewerUser"
                (closed)="implementationReviewerUserText=''" (click)="focusMethod('implementationReviewerUsertSearch')"
                (keydown.enter)="focusMethod('implementationReviewerUsertSearch')"
                [ngClass]="{'odd-item-mat-select': isImplementationReviewerUserOdd == selectedImplementationReviewerUser}"
                [disabled]="auditeeSectionFrozen && !elite_assign_to_user_level_2">
                <input type="search" id="implementationReviewerUsertSearch" class="dropdownsearchstyle"
                  [(ngModel)]="implementationReviewerUserText" matInput placeholder="search">
                <mat-option class="unselectStyle"
                  (onSelectionChange)="onSelect($event,'implementation-reviewer-validation',null);"
                  [value]="null">Un-select</mat-option>
                <mat-option
                  *ngFor="let item of implementationReviewerDropdown| assessmentSearch :implementationReviewerUserText"
                  (onSelectionChange)="onSelect($event,'implementation-reviewer-validation',item);"
                  [value]="item.valueExp">
                  {{ item.displayExp }}
                </mat-option>
              </mat-select>
            </div>

            <div class="col-md-3 inner-align">
              <div>
                <label for="email" id="expectedClosureDate-validation">
                  {{dynamicLabel['EXPECTED_CLOSURE_DATE'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['EXPECTED_CLOSURE_DATE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['EXPECTED_CLOSURE_DATE']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [disabled]="closureDateDisableFlag || (auditorSectionFrozen && !elite_primary_auditee && !elite_assign_to_user_level_1)"
                [bsConfig]="futureDateConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="findingsDetailsData.expectedClosureDate">
            </div>

            <div class="col-md-3 inner-align">
              <div>
                <label for="email" id="expected-closure-date-validation">
                  {{dynamicLabel['ACTUAL_CLOSED_DATE'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['ACTUAL_CLOSED_DATE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ACTUAL_CLOSED_DATE']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [disabled]="!elite_actual_closed_date && !elite_assign_to_user_level_2" [bsConfig]="futureDateConfig"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="findingsDetailsData.actualClosedDate">
            </div>

            <div class="col-md-3 inner-align">
              <div>
                <label for="email">
                  {{dynamicLabel['IS_CAPA_REQUIRED'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes"
                  [matTooltip]="dynamicLabel['AUDIT_REFERENCES']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <mat-slide-toggle color="primary" name="isPrimaryProduct"
                [disabled]="auditorSectionFrozen && !elite_primary_auditee && !elite_assign_to_user_level_1"
                [(ngModel)]=" findingsDetailsData.isCapaRequired" (change)="onIsCAPARequiredChange($event)">
                <ng-container *ngIf="findingsDetailsData.isCapaRequired; else no">
                  <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                </ng-container>
                <ng-template #no>
                  <span style="color: red;">No</span>
                </ng-template>
              </mat-slide-toggle>
            </div>

            <div class="col-md-5 inner-align" *ngIf="findingsDetailsData.capaDetails">
              <div><label for="email ">{{dynamicLabel['CAPA_DETAILS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['CAPA_DETAILS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CAPA_DETAILS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="d-flex">
                <div class="col-sm-11">
                  <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                    [(ngModel)]="findingsDetailsData.capaDetails" [disabled]="true"></textarea>
                </div>
                <div *ngIf="(findingsDetailsData.capaNo && !auditorSectionFrozen) || editableCapa" class="col-sm-1"
                  style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
                  (click)="openSearchCapaRequiredPopup()" (keydown.enter)="openSearchCapaRequiredPopup()">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3 inner-align" id="search-container"
              *ngIf="findingsDetailsData.isCapaRequired && (!findingsDetailsData.capaNo)">
              <div><label id="capa-validation" for="email">CAPA Activity</label></div>
              <div style="display: flex; justify-content: center;">
                <div class="col-sm-11" style="position: relative;">
                  <input id="vendorName" class="input-filed-continers" type="text" style="cursor: not-allowed;"
                    [(ngModel)]="findingsDetailsData.capaNo" [disabled]="true">
                </div>
                <div class="col-sm-1"
                  style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
                  (click)="openSearchCapaRequiredPopup()" (keydown.enter)="openSearchCapaRequiredPopup()">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>

            <div class="col-md-3 inner-align">
              <div>
                <label for="email" id="due-date-validation">
                  {{dynamicLabel['DUE_DATE'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['DUE_DATE']?.fieldNotes"
                  [matTooltip]="dynamicLabel['DUE_DATE']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <input type="text" class="form-control data-picker-continer" bsDatepicker
                [disabled]="dueDateDisableFlag || (auditorSectionFrozen && !elite_primary_auditee && !elite_assign_to_user_level_1)"
                [bsConfig]="futureDateConfig" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="findingsDetailsData.dueDate">
            </div>

            <div class="col-md-6 inner-align" [hidden]="dynamicLabel['CLOSURE_COMMENTS']?.isRemovable == 'Y'">
              <div class="field-row-down">
                <label id="closure-comments-validation" for="email">
                  {{ dynamicLabel['CLOSURE_COMMENTS'].fieldName }}
                  <span class="mandatory-symbol"
                    *ngIf="findingsDetailsData?.status && (findingsDetailsData?.status != 'Open' || (findingsDetailsData?.status == 'Open' && qualityService.activity?.status == 'Findings In Progress'))">*</span>
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['CLOSURE_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['CLOSURE_COMMENTS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>

              <div class="row align-items-center">
                <div class="col-sm-11 pl-0 pr-1 hideToolbar">
                  <st-editor [(ngModel)]="findingsDetailsData.closureComments" [config]="config"
                    [disabled]="auditorSectionFrozen  && !elite_lead_auditor" (paste)="onPaste($event)"
                    [spellcheck]="true" (focusout)="onFieldFocusout()"
                    (blur)="onNgModelChange($event, 'closure-comments-validation')">
                  </st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit pl-0 pr-0"
                  (click)="(auditorSectionFrozen  && !elite_lead_auditor)  ? openEditor('Closure Comments', 'eye') : openEditor('Closure Comments', 'edit')"
                  (keydown.enter)="(auditorSectionFrozen  && !elite_lead_auditor)  ? openEditor('Closure Comments', 'eye') : openEditor('Closure Comments', 'edit')">
                  <i *ngIf="!((auditorSectionFrozen  && !elite_lead_auditor) )" class="far fa-edit"></i>
                  <i *ngIf="(auditorSectionFrozen  && !elite_lead_auditor) " class="fa fa-eye eye"></i>
                </div>
              </div>
            </div>
            <div class="col-md-6 inner-align" [hidden]="dynamicLabel['ADDITIONAL_FIELD']?.isRemovable == 'Y'">
              <div class="row">
                <label id="additional-validation" for="email">
                  {{dynamicLabel['ADDITIONAL_FIELD'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['ADDITIONAL_FIELD']?.fieldNotes"
                  [matTooltip]="dynamicLabel['ADDITIONAL_FIELD']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <div class="hideToolbar col-sm-11">
                  <st-editor [(ngModel)]="findingsDetailsData.additionalField"
                    (blur)="onNgModelChange($event,'finding-validation')" [config]="config" (paste)="onPaste($event)"
                    [spellcheck]="true"></st-editor>
                </div>
                <div class="col-sm-1 angular-editor-edit" (click)="openEditor('Additional Field', 'edit')"
                  (keydown.enter)="openEditor('Additional Field', 'edit')">
                  <i class="far fa-edit"></i>
                </div>
              </div>
            </div>
            <!-- Response reviewer -->

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseReviewRequestedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_REVIEW_REQUESTED_ON'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEW_REQUESTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseReviewRequestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseReviewRejectedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_REVIEW_REJECTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEW_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEW_REJECTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseReviewRejectedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseReviewCompletedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_REVIEW_COMPLETED_ON'].fieldName}}
                </label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEW_COMPLETED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseReviewCompletedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseReviewStatus!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_REVIEW_STATUS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEW_STATUS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEW_STATUS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control" type="text" [(ngModel)]="findingsDetailsData.responseReviewStatus" disabled>
              </div>
            </div>

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseReviewerComments!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_REVIEWER_COMMENTS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_REVIEWER_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_REVIEWER_COMMENTS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control" type="text" [(ngModel)]="findingsDetailsData.responseReviewerComments"
                  disabled>
              </div>
            </div>
            <!-- Verification reviewer -->
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseVerificationRequestedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_VERIFICATION_REQUESTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_VERIFICATION_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_VERIFICATION_REQUESTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseVerificationRequestedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseVerificationRejectedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_VERIFICATION_REJECTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_VERIFICATION_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_VERIFICATION_REJECTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseVerificationRejectedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.responseVerifiedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['RESPONSE_VERIFIED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_VERIFIED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_VERIFIED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.responseVerifiedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>
            <div class="col-md-6 inner-align" *ngIf="findingsDetailsData.responseVerificationComments!=null">
              <div class="row"><label for="email">{{dynamicLabel['RESPONSE_VERIFICATION_COMMENTS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_VERIFICATION_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['RESPONSE_VERIFICATION_COMMENTS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control" type="text"
                  [(ngModel)]="findingsDetailsData.responseVerificationComments" disabled>
              </div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationVerificationRequestedOn!=null">
              <div class="row"><label
                  for="email">{{dynamicLabel['IMPLEMENTATION_VERIFICATION_REQUESTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_VERIFIED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_VERIFIED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationVerificationRequestedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled></div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationVerificationRejectedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['IMPLEMENTATION_VERIFICATION_REJECTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_VERIFICATION_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_VERIFICATION_REJECTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationVerificationRejectedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>

            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationVerifiedOn!=null">
              <div class="row"><label for="email">{{dynamicLabel['IMPLEMENTATION_VERIFIED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_VERIFIED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_VERIFIED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationVerifiedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled></div>
            </div>
            <div class="col-md-6 inner-align" *ngIf="findingsDetailsData.implementationVerificationComments!=null">
              <div class="row"><label
                  for="email">{{dynamicLabel['IMPLEMENTATION_VERIFICATION_COMMENTS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_VERIFICATION_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_VERIFICATION_COMMENTS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control" type="text"
                  [(ngModel)]="findingsDetailsData.implementationVerificationComments" disabled></div>
            </div>
            <!-- Implement reviewer -->
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationReviewRequestedOn!=null">
              <div class="row"><label
                  for="email">{{dynamicLabel['IMPLEMENTATION_REVIEW_REQUESTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEW_REQUESTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEW_REQUESTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationReviewRequestedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled></div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationReviewRejectedOn!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['IMPLEMENTATION_REVIEW_REJECTED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEW_REJECTED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEW_REJECTED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row">
                <input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationReviewRejectedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled>
              </div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationReviewCompletedOn!=null">
              <div class="row"><label
                  for="email">{{dynamicLabel['IMPLEMENTATION_REVIEW_COMPLETED_ON'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEW_COMPLETED_ON']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEW_COMPLETED_ON']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control text-uppercase" type="text"
                  [value]="findingsDetailsData.implementationReviewCompletedOn| date : (appService.getOneQmsDateFormat + ' HH:mm:ss')"
                  disabled></div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationReviewStatus!=null">
              <div class="row">
                <label for="email">{{dynamicLabel['IMPLEMENTATION_REVIEW_STATUS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEW_STATUS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEW_STATUS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control" type="text"
                  [(ngModel)]="findingsDetailsData.implementationReviewStatus" disabled></div>
            </div>
            <div class="col-md-3 inner-align" *ngIf="findingsDetailsData.implementationReviewerComments!=null">
              <div class="row"><label for="email">{{dynamicLabel['IMPLEMENTATION_REVIEWER_COMMENTS'].fieldName}}</label>
                <span class="info-icon" *ngIf="dynamicLabel['IMPLEMENTATION_REVIEWER_COMMENTS']?.fieldNotes"
                  [matTooltip]="dynamicLabel['IMPLEMENTATION_REVIEWER_COMMENTS']?.fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
              </div>
              <div class="row"><input class="form-control" type="text"
                  [(ngModel)]="findingsDetailsData.implementationReviewerComments" disabled>
              </div>
            </div>
          </div><br>

          <div class="form-template ActivityPage" id="Documents" style="margin-top:1%;">
            <div class="menu-container">
              <div class="row menu-row-container">
                <div class="col-sm-6 gridName-container">
                  <span class="gridName">Documents</span>
                </div>
              </div>
            </div>
            <app-task-documents [activity]="this.objForDocuments"></app-task-documents>
          </div><br>

          <div class="button-continer btn-align" mat-dialog-actions
            [hidden]="this.qualityService.activity.status=='Closed' || this.findingsDetailsData.status=='Obsoleted'">
            <button mat-stroked-button class="addButton"
              *ngIf="showsavebtn || (this.auService.isPeerReviewer && (this.qualityService.activity.status=='Pending Peer Review'||this.qualityService.activity.status=='Peer Review Inprogress')) "
              (click)="saveFindingDetails(findingsDetailsData)">
              <i class="fas fa-user-edit"></i> Save
            </button>
          </div>
        </div>
      </div>
    </fieldset>
  </mat-tab>
  <mat-tab label="Risk Assessment"
    *ngIf="qualityService.activity?.isRiskCalculationReqd && qualityService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'">
    <ng-template mat-tab-label>
      <span>
        <img src="../../assets/img/warning (1).png" alt="tasks" width="20" height="20" class="ng-star-inserted">
      </span>&nbsp;
      <span>Risk Assessment</span>
    </ng-template>
    <div class="form-template ActivityPage" id="Risk Assesment" style="margin-top:1%;">
      <app-risk [pagename]="'findings'" *ngIf="selectedTabName === 'Risk Assessment' && loadRisk"></app-risk>
    </div>
  </mat-tab>
</mat-tab-group>
<ng-template #confirmWithReasonPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelFunc()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-sm-12"
          *ngIf="buttonLabel=='Review'||buttonLabel==='Approve'||buttonLabel=='Verify Response'||buttonLabel==='Verify Implementation'||this.buttonLabel=='Review Response'||this.buttonLabel=='Review Implementation'">
          <div><label id="reviewAndapprove-validation" for="email">{{buttonLabel}}</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of reviewStatus" [value]="status"
              (change)="radioChange($event)">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="col-md-12 fieldStyle3" *ngIf="isEsignRequired">
          <div class=""><label for="username ">User Name</label><span class="mandatory-symbol">*</span></div>
          <div class=""> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled></div>
        </div>
        <div class="col-md-12" *ngIf="(isEsignRequired && !isAdEnabled)">
          <div class=""><label id="password-validation" for="pass ">Password</label><span
              class="mandatory-symbol">*</span></div>
          <div class=""> <input id="EsignRequiredPassword" autocomplete="off" onpaste="return false;"
              ondrop="return false;" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
              (focusout)="onPasswordFieldFocusout()" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
        </div>
        <div class="col-md-12"
          *ngIf="this.buttonLabel=='Review' || this.buttonLabel=='Approve'||this.buttonLabel=='Reject Response'|| this.buttonLabel=='Accept Response'|| this.buttonLabel=='Accept Response/No Implementation Required' || this.buttonLabel == 'Obsolete' || this.buttonLabel == 'Delete'
          || this.buttonLabel=='Reject Implementation'|| this.buttonLabel=='Accept Implementation' || this.buttonLabel=='Review Response'|| this.buttonLabel == 'Verify Response' || this.buttonLabel === 'Verify Implementation'||this.buttonLabel=='Review Implementation'">
          <div><label id="reason-validation" for="reason"> Comments</label>
            <span class="mandatory-symbol" *ngIf="selectedStatus?.includes('Rejected')">*</span>
          </div>
          <textarea rows="4" class="input-filed-textarea" type="text" [(ngModel)]="reason"></textarea>
        </div>

        <!-- Deferred -->

      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button *ngIf="buttonLabel != 'Defer Action'" mat-stroked-button class="addButton"
        (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? config1 : config" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<!--Excel & pdf -->

<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title
      }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 12 fields for a cleaner and more readable PDF
      </span>
    </label>
  </div>

  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>

    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #columns [(ngModel)]="selectedColumns"
          (closed)="excelPdfSearchText=''" (click)="focusmethod('focus-excel-pdf-search')"
          (keydown.enter)="focusmethod('focus-excel-pdf-search')">
          <input type="search" id="focus-excel-pdf-search" class="dropdownsearchstyle" [(ngModel)]="excelPdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="isAllColumns" (change)="toggleAllSelection('columns')">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of dropDownForPdfColumn | multiAssessmentSearchPipe : excelPdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<!-- PDF Report Popup-->
<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportTemplate-validation" for="email">Report Template</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">


        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-group-search')"
          (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onPdfDetailValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onPdfDetailValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Report Logo</label>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
          (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
          (keydown.enter)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReportGenerateFuntion()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="exportReportCancelPopupFuntion()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-switchuser #switchUserPopup1 (valueEmitter)="onSwitchChildValueEmitted()"></app-switchuser>
<app-add-map-capa [findings]="findingInfo" (valueEmitter)="onCapaEmitted()"></app-add-map-capa>
<app-moduletype (valueEmitter)="onModuleTypeEmitted($event)" [parentData]="moduleTypeData"></app-moduletype>
